/**
 * @description main模块内容注册
 */

import angular from 'angular';

/************************************** module ***********************************************/
import { CommonModule } from '../common/common.module';


/************************************** Config ***********************************************/


/************************************** Service ***********************************************/

import { RuntimeContext } from './runtime-context.service';


import { PaymentRestService } from './rest/payment/payment-rest.service';





/************************************** 内容注册 ***********************************************/

let mainModule = angular.module("qpmn-main", [CommonModule.name])

mainModule
    .service({
        runtimeContext: RuntimeContext,
        paymentRestService: PaymentRestService
    })


export { mainModule };
